import React, { ComponentProps, FC } from 'react'

import { SpaceTimeLocation } from 'components/presentational/SpaceTimeLocation'
import { GQLGender } from 'generated-graphql/graphql'

import { DistanceUnknownSeenRecently } from './DistanceUnknownSeenRecently'
import { useShowUserLocationAbTest } from './hooks/useShowUserLocationAbTest'

export const SpaceTimeLocationHiddenAbTest: FC<
  SpaceTimeLocationHiddenAbTestProps
> = (props) => {
  const { showUserLocation } = useShowUserLocationAbTest()
  const { statuses, gender, inlineText } = props

  return (
    <SpaceTimeLocation
      {...props}
      location={
        !showUserLocation && (
          <DistanceUnknownSeenRecently
            showSeenRecently={!statuses!.online?.isOn}
            gender={gender}
            separator={inlineText ? '. ' : <br />}
          />
        )
      }
    />
  )
}

type SpaceTimeLocationProps = ComponentProps<typeof SpaceTimeLocation>
type SpaceTimeLocationHiddenAbTestProps = Omit<
  SpaceTimeLocationProps,
  'showUserLocation'
> & {
  gender: GQLGender | string
  inlineText?: boolean
}
